import { Text } from '@chakra-ui/react'
import { BaseLabel } from '@hb/shared'
import { FC } from 'react'
import { Container } from '../../Container'
import { getInputSizeTokens, useInputSize } from './Shared/sizes'

const Hint: FC<BaseLabel & { fontSize: string }> = ({ text, style, fontSize }) => (
  <Text fontSize={fontSize} pb={1} color="gray.600" style={style}>
    <i>{text}</i>
  </Text>
)

const renderHint = (label: BaseLabel, fontSize: string, index?: number) =>
  typeof label === 'string' ? (
    <Hint key={`label_${index}`} text={label} fontSize={fontSize} />
  ) : (
    <Hint key={`label_${index}`} {...label} fontSize={fontSize} />
  )

const Hints: FC<{ hints?: BaseLabel[] }> = ({ hints }) => {
  const fontSize = getInputSizeTokens(useInputSize()).hintFontSize
  if (!hints) return null
  return (
    <Container
      style={{
        alignItems: 'flex-start',
      }}>
      {hints.map((l, index) => renderHint(l, fontSize, index))}
    </Container>
  )
}

export default Hints
